<template>
  <div>
    <h2>Who do we contact in the event of your death?</h2>
    <p>We will notify the following person/s in the event of your passing.</p>
    <PeopleList
      :people="relations.emergencyContacts"
      :testator="testator"
      relation="EMERGENCY_CONTACT"
      :limit="2"
      :emergency-contacts="true"
    />

    <div class="button-container">
      <DefaultButton
        @defaultButtonClicked="redirectBack"
        :small="true"
        :callout="'left'"
      />
      <GradientButton
        @gradientButtonClicked="redirectToNext"
        :title="'Next'"
        :callout="'right'"
        :small="true"
      />
    </div>
  </div>
</template>

<script>
  import PeopleList from './PeopleList.vue';

  export default {
    name: 'EmergencyContacts',
    components: {
      PeopleList,
    },
    props: {
      testator: { type: Object, required: true },
      relations: { type: Object, required: true },
    },
    computed: {},
    methods: {
      redirectToNext() {
        if (this.wizard == 'trust' || this.wizard == 'children') {
          this.$router.push({ name: 'PeopleOverview', hash: '#children' });
        } else {
          this.$router.push('executor');
        }
      },
      redirectBack() {
        if (this.wizard == 'trust') {
          this.$router.push({ name: 'PeopleOverview', hash: '#children' });
        } else if (this.testator.hasChildren) {
          if (this.testator.willCountry == 'GB') {
            this.$router.push('guardian');
          } else {
            this.$router.push('trust');
          }
        } else {
          this.$router.push('children');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-container {
    margin-top: 40px;
    display: flex;
    gap: 20px;
  }
</style>
